import { Grid, Link } from "@mui/material";
import React from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

interface TermsProps {
  close: any;
}

function TermsConditions(props: TermsProps) {
  return (
    <Grid padding={1}>
      <Grid
        width={"100%"}
        display={"flex"}
        justifyContent={"end"}
        position={"sticky"}
        top={0}
        zIndex={1}
      >
        <CloseOutlinedIcon style={{ cursor: "pointer" }} onClick={props.close} />
      </Grid>
      <h1>Terms of Use</h1>
      <h3>1.THE TERMS</h3>
      <p>
        This Agreement is a binding agreement between SML Isuzu Limited (Referred as company) and
        Minda iConnect Pvt. Ltd. (both companies together as the "Service Provider") and you with
        respect to your participation (the "User") in the Services and your consumption of Services
        as defined by Your or any other users interaction with or use of all or some of our -
        website, hardware device ("Hardware") and user applications (Application). Given the
        importance of the terms of this Agreement, we encourage you to study them carefully.
      </p>
      <p>
        Service Provider is committed to protecting your privacy and shall not share your location,
        geo coordinate data with any 3rd party such that it can be associated with an individual,
        unless required to conduct our Services of vehicle tracking and vehicle health monitoring
        system (hereinafter referred to “services”) provided to you or required by law.
      </p>
      <p>
        You are solely responsible for all data, information, feedback, suggestions, text, content
        and other materials that you upload, post, deliver, provide or otherwise transmit or store
        (hereafter "post(ing)") in connection with or relating to the Services ("Your Content"). You
        are responsible for maintaining the confidentiality of your login, password and account and
        for all activities that occur under your login or account.
      </p>
      <p>
        We reserve the right to access your account and the information/data in order to respond to
        your requests for technical support, service support or with regard to any future
        development of the vehicle. You represent and warrant that:
      </p>
      <ul>
        <li>you have full power and authority to enter into this term of use;</li>
        <li>
          you own all the content uploaded by you while using our services and have obtained all the
          requisite permissions and have the right to upload the data prior to uploading the same;
        </li>
        <li>
          you undertake that your content and other activities in connection with using our Services
          does not violate, infringe or misappropriate any third parties copyright, trademark, right
          of privacy and publicity or other personal or proprietary rights;
        </li>
        <li>
          you undertake that you shall be exclusively responsible for any liability arising due to
          any potential breach which may occur as a result of your usage of our Services.
        </li>
      </ul>
      <p>
        We have the right, but not the obligation, to monitor the Services, Hardware, or Your
        Content. You further agree that we may remove or disable any Content at any time for any
        reason (including, but not limited to allegations from third parties or authorities relating
        to such Content), or for no reason at all.
      </p>

      <h3>2. DELIVERY OF SERVICES AND USAGE OF USER DATA</h3>

      <p>
        <strong>2.1</strong> Note that in order for the Services to be delivered, the mobile device
        or other user devices, onto which the Application is installed, must have adequate network
        and data service and should have appropriate operating system and software required for the
        application to work, and the Hardware must be properly activated and installed in your
        vehicle and be in a geographical area that has telecom network of our telecom partner.
      </p>
      <p>
        <strong>2.2</strong> Service Provider uses reasonable security measures to protect the data
        they receive via the Services and Hardware. However, service provider does not guarantee
        that third parties will never defeat our security measures. You acknowledge that you are
        using the Services and sharing information at your own risk.
      </p>
      <p>
        <strong>2.3</strong> Service Provider has the right to use or share Data generated by You
        with its partners and affiliates or 3rd parties, for providing services to You or for
        analysis or marketing and promotional or other commercial purposes or if required by law.
        When Data is used for purposes other than providing services to you then such data shall be
        anonymised.
      </p>

      <h3>3. GENERAL</h3>

      <p>
        <strong>3.1</strong> The Website is an Internet based portal owned and operated by the
        Company. Use of Services is offered to you subject to acceptance of all the terms,
        conditions and notices contained in the Terms, along with any amendments made by the Company
        at its sole discretion and posted on the Website, including by way of imposing any charge
        for access to or use of a Services. By (i) using all or part of our Services in any way; or
        (ii) by creating the user id for using the services in <Link> oemtool.syaa.xyz </Link>
        you agree that you have read, understood and agreed to be bound by these Terms of use.
      </p>
      <h3>4. USER ACCOUNT, PASSWORD, AND SECURITY </h3>
      <p>
        <strong>4.1</strong> The Company may make the Services available to You only if You have
        provided Service Provider certain required User information and / or created an account
        ("Account") by creating your log-in ID and password (collectively, the "Account
        Information"). The Services may also be subject to procedures for use of the Website, Terms
        of Offer For Sale, uploaded guide, rules, additional terms of service, or other disclaimer &
        notices, if any ("Additional Terms").
      </p>
      <p>
        <strong>4.2</strong> You will be responsible for maintaining the confidentiality of the
        Account Information, and are fully responsible for all activities that occur through your
        log in id. You agree to (a) immediately notify Service Provider of any unauthorized use of
        your Account Information or any other breach of security, and (b) ensure that You exit from
        Your Account at the end of each session. Service Provider cannot and will not be liable for
        any loss or damage arising from your failure to comply with these conditions. You may be
        held liable for losses incurred by Service Provider or any other user of or visitor to the
        Website due to unauthorized use of Your Account as a result of your failure in keeping Your
        Account Information secure and confidential.
      </p>
      <p>
        <strong>4.3</strong> You shall ensure that the Account Information provided by you in the
        Website's registration form is complete, accurate and up-to-date. Use of another user's
        Account Information for availing the Services is expressly prohibited and you shall be
        solely liable for any claims or litigations raised in this behalf.
      </p>
      <p>
        <strong>4.4</strong> If You provide any information that is untrue, inaccurate, not current
        or incomplete (or becomes untrue, inaccurate, not current or incomplete), or Service
        Provider has reasonable grounds to suspect that such information is untrue, inaccurate, not
        current or incomplete, company has the right to suspend or terminate Your Account and refuse
        any and all current or future use of the Services (or any portion thereof).
      </p>
      <p>
        <strong>5. PRICING INFORMATION</strong>
      </p>
      <p>
        <strong>5.1</strong> You agree to provide correct and accurate credit / debit card details
        with transactional PIN/OTP to the approved secured payment gateway for availing Services.
        The information provided by you on the payment gateway will not be utilized or shared with
        any third party unless required to complete your transaction or in relation to fraud
        verifications or by law, regulation or court order. You will be solely responsible for the
        security and confidentiality of your credit / debit card details.
      </p>
      <p>
        <strong>5.2</strong> Service Provider shall be under no liability whatsoever in respect of
        any loss or damage arising directly or indirectly out of the authorization for any
        transaction for any reason whatsoever.
      </p>
      <p>
        <h3>6. USER OBLIGATIONS</h3>
      </p>
      <p>
        <strong>6.1</strong> Subject to compliance with the Terms of Use, Service Provider grants
        you a non-exclusive, limited privilege to access and use the Website.
      </p>
      <p>
        <strong>6.2</strong> You agree to use the Services and the materials provided therein only
        for purposes that are permitted by: (a) the Terms; and (b) any applicable law, regulation or
        generally accepted practices or guide in the relevant jurisdictions.
      </p>
      <p>
        <strong>6.3</strong> You agree to adhere to all limitations on dissemination, use and
        reproduction of any materials (such as the product catalogues) that you will access the
        Website in accordance with the Terms and particularly Section 8.
      </p>
      <p>
        <strong>6.4</strong> You agree not to access (or attempt to access) the Website and the
        materials or Services by any means other than through the interface that is provided by
        Service Provider. You shall not use any deep-link, robot, spider or other automatic device,
        program, algorithm or methodology, or any similar or equivalent manual process, to access,
        acquire, hack, copy or monitor any Hardware, Application, Website or Content (as defined
        below), or in any way reproduce or circumvent the navigational structure or presentation of
        the Website, Application, materials or any Content, to obtain or attempt to obtain any
        materials, documents or information through any means not specifically made available
        through the Website.
      </p>
      <p>
        <strong>6.5</strong> By accessing or using the Website or Services, You may be exposed to
        content from other users that you may consider offensive, indecent or otherwise
        objectionable. Service Provider disclaims all liabilities arising in relation to such
        offensive content on the Website.
      </p>
      <p>
        <strong>6.6</strong> Our Services may allow you to post or upload files, data, comments or
        any other material. You hereby undertake to ensure that such material is not offensive and
        is in accordance with applicable laws. Further, you undertake not to: Defame abuse, harass,
        threaten or otherwise violate the legal rights of others as well as that of the service
        providers;
      </p>
      <p>
        <strong>6.7</strong> You undertake not to Impersonate any person or entity, or falsely state
        or otherwise misrepresent Your affiliation with a person or entity;
      </p>
      <p>
        <strong>6.8</strong> You undertake not to publish, post, upload, distribute or disseminate
        any inappropriate, profane, defamatory, infringing, obscene, indecent or unlawful topic,
        name, material or information through any bookmark, tag or keyword;
      </p>
      <p>
        <strong>6.9</strong> You undertake not to upload files that contain software or other
        material protected by applicable intellectual property laws unless you own or control the
        rights thereto or have received all necessary consents;
      </p>
      <p>
        <strong>6.10</strong> You undertake not to upload or distribute files that contain viruses,
        corrupted files, or any other similar software or programs that may damage the operation of
        the Website or another's computer;
      </p>
      <p>
        <strong>6.11</strong> You undertake not to engage in any activity that interferes with or
        disrupts access to the Website or the Services (or the servers and networks which are
        connected to the Website);
      </p>
      <p>
        <strong>6.12</strong> You undertake not to attempt to gain unauthorized access to any
        portion or feature of the Services, any other systems or networks connected to the Services,
        to any of our server, by any illegitimate means (including such as hacking and password
        mining);
      </p>
      <p>
        <strong>6.13</strong> You undertake not to probe, scan or test the vulnerability of any
        portion of our Services or any network connected to the Services, nor breach the security or
        authentication measures on the website or any network connected to the website. You may not
        reverse look-up, trace or seek to trace any information on any other user, of or visitor to,
        the website, or any other customer of Service Provider, including any Service Provider
        Account not owned by You, to its source, or exploit the Website or Services or information
        made available or offered by or through the Website, in any way whether or not the purpose
        is to reveal any information, including but not limited to personal identification
        information;
      </p>
      <p>
        <strong>6.14</strong> You undertake not to disrupt or interfere with the security of, or
        otherwise cause harm to, the Website, systems resources, accounts, passwords, servers or
        vehicle or networks connected to or accessible through the Services or any affiliated or
        linked sites; collect or store data about other users and use any device or software to
        interfere or attempt to interfere with the proper working of the Services or any transaction
        being conducted on the Services, or with any other person's use of the Services;
      </p>
      <p>
        <strong>6.15</strong> You undertake not to use the Services or any material or Content for
        any purpose that is unlawful or prohibited by the Terms, or to solicit the performance of
        any illegal activity or other activity which infringes the rights of Service Provider or
        other third parties;
      </p>
      <p>
        <strong>6.16</strong> You undertake not to violate any applicable laws or regulations for
        the time being in force within or outside India; You further undertake not to modify, copy,
        distribute, transmit, display, perform, reproduce, publish, license, create derivative works
        from, transfer, or sell any information, images or software obtained from the Services
        through Reverse engineering or any other means.
      </p>
      <p>
        <strong>6.17</strong> You agree that you are solely responsible to Service Provider and to
        any third party for any breach of your obligations under the Terms and for the consequences
        for any such breach.
      </p>
      <p>
        <h3>7. USE OF MATERIALS</h3>
      </p>
      <p>
        <strong>7.1</strong> Except as expressly indicated to the contrary herein or in any
        applicable Additional Terms, Service Provider hereby grants You a non-exclusive, freely
        revocable (upon notice from Service Provider ), non-transferable access to view and print
        product catalogue available on the Website, subject to the following conditions:
      </p>
      <ul>
        <li>
          You may access and use the materials solely for personal, informational, and internal
          purposes, in accordance with the Terms;
        </li>
        <li>You will not modify or alter product catalogue available on the Website; and</li>
        <li>
          You may not remove any text, copyright or other proprietary notices contained in the
          product catalogue available on the Website.
        </li>
      </ul>
      <p>
        <strong>7.2</strong> The rights granted to you as specified above are not applicable to the
        design, layout or look and feel of the Website. Such elements of the Website are protected
        by intellectual property rights and may not be copied or imitated in whole or in part. The
        product catalogue available on the Website may be copied or retransmitted unless expressly
        prohibited by Service Provider.
      </p>
      <p>
        <h3>8. INTELLECTUAL PROPERTY RIGHTS</h3>
      </p>
      <p>
        <strong>8.1</strong> The Website and the processes, and their selection and arrangement,
        including but not limited to all text, graphics, user interfaces, visual interfaces, sounds
        and music (if any), artwork and computer code (collectively, the "Content") on the Website
        is owned and controlled by Service Provider and the design, structure, selection,
        coordination, expression, look and feel and arrangement of such Content is protected by
        copyright, patent and trademark laws, and various other intellectual property rights.
      </p>
      <p>
        <strong>8.2</strong> The trademarks, logos and service marks displayed on any component of
        the Services ("Marks") are the property of Service Provider. You are not permitted to use
        the Marks without the prior consent of Service Provider in writing or the third party that
        owns the Marks.
      </p>
      <p>
        <strong>8.3</strong> Service Provider owns all intellectual property rights to the trademark
        and variants thereof, and the domain name, including, without limitation, any and all
        rights, title and interest in and to copyright, related rights, patents, utility models,
        designs, know-how, trade secrets and inventions (patent pending), goodwill, source code,
        meta tags, databases, text, content, graphics, icons, and hyperlinks.
      </p>
      <p>
        <strong>8.4</strong> Except as expressly provided herein, you acknowledge and agree that You
        shall not copy, republish, post, display, translate, transmit, reproduce or distribute any
        Content through any medium without obtaining the necessary authorization from Service
        Provider or third party owner of such Content.
      </p>
      <p>
        <h3>9. DISCLAIMER OF WARRANTIES & LIABILITY</h3>
      </p>
      <p>
        You expressly understand and agree that, to the maximum extent permitted by applicable law:
      </p>
      <p>
        <strong>9.1</strong> You agree to indemnify, defend and hold harmless Service Provider from
        and against any and all losses, liabilities, claims, damages, demands, costs and expenses
        (including legal fees and disbursements in connection therewith and interest chargeable
        thereon) asserted against or incurred by Service Provider that arise out of, result from, or
        may be payable by virtue of, any breach of any representation, warranty, covenant or
        agreement made or obligation to be performed by You pursuant to these Terms which become
        applicable to your usage of Services.
      </p>
      <p>
        <strong>9.2</strong> In no event shall Service Provider , its officers, directors,
        employees, partners or vendors be liable to You, the Vendor or any third party for any
        special, incidental, indirect, consequential or punitive damages whatsoever, including those
        resulting from loss of use, data or profits, whether or not foreseeable or whether or not
        Service Provider has been advised of the possibility of such damages, or based on any theory
        of liability, including breach of contract or warranty, negligence or other tortious action,
        or any other claim arising out of or in connection with Your purchase of the products and
        services herein. Notwithstanding anything to contrary, Service Provider’s entire liability
        to you under this Terms of Offer for Sale or otherwise shall be the refund of the money
        charged from You, under which the unlikely liability arises.
      </p>
      <p>
        <strong>9.3</strong> Service Provider will not be liable for any loss that you may incur as
        a consequence of unauthorized use of your account or account information or any services or
        materials, either with or without your knowledge. Service Provider endeavours to ensure that
        all the information uploaded by the service provider on the website is correct, and provide
        warranties relating to the quality, accuracy of product or service. Service Provider shall
        not be responsible for the delay or inability to use the website or related functionalities,
        the provision of or failure to provide functionalities, or for any information, software,
        products, functionalities and related graphics obtained through the website, or otherwise
        arising out of the use of the website, whether based on contract, tort, negligence, strict
        liability or otherwise. Further, Service Provider shall not be responsible for
        non-availability of the website during periodic maintenance operations or any unplanned
        suspension of access to the website that may occur due to technical reasons or for any
        reason. The user understands and agrees that any material or data downloaded or otherwise
        obtained through the website is done entirely at their own discretion and risk and they will
        be solely responsible for any damage to their computer systems or loss of data that results
        from the download of such material or data. Service Provider is not responsible for any
        typographical error leading to any invalidity of any kind. Service Provider accepts no
        liability for any errors or omissions, with respect to any information provided to you by
        itself or on behalf of third parties.
      </p>
      <p>
        <strong>9.4</strong> Service Provider shall not be liable for any third party product or
        services. The advertisements available on e-mail or website with respect to any third party
        website or the products and services are for information purpose only.
      </p>
      <p>
        <h3>10. VIOLATION OF THE TERMS OF USE</h3>
      </p>
      <p>
        <strong>10.1</strong> Service Provider may, in its sole discretion and without prior notice,
        terminate Your access to the Website if Service Provider determines that You have violated
        the Terms of use. Any violation by You of the Terms will constitute an unlawful and unfair
        business practice, and will cause irreparable harm to Service Provider , for which monetary
        damages is likely to be inadequate, and You consent to Service Provider obtaining any
        injunctive or equitable relief that Service Provider deems necessary or appropriate. These
        remedies are in addition to any other remedies Service Provider may have at law or in
        equity.
      </p>
      <p>
        <h3>11. TERMINATION</h3>
      </p>
      <p>
        <strong>11.1</strong> The Terms will continue to apply until terminated by either you or
        Service Provider as set forth below. If you want to terminate your agreement with Service
        Provider, you may do so by (i) not accessing the Services by deactivating / deleting the
        device from “Manage Your Device” in www.smlsaarthi.com.
      </p>
      <p>
        <strong>11.2</strong> Service provider may at its discretion and at any time with or without
        notice / information terminate or suspend the Terms without cause or with cause if:
      </p>
      <p>
        <strong>11.2.1</strong> You breach any of the provisions of the Terms, the Privacy Policy or
        any other terms, conditions, or policies that may be applicable to You;
      </p>
      <p>
        <strong>11.2.2</strong> Service provider is required to do so by law (for example, where the
        provision of the Services to You is, or becomes, unlawful or pursuant to a request by a
        regulatory authority);
      </p>
      <p>
        <strong>11.2.3</strong> The provision of the Services to you by Service provider is in our
        opinion, no longer commercially viable;
      </p>
      <p>
        <strong>11.2.4</strong> Service provider has elected to discontinue, with or without reason,
        access to the Website, the Services (or any part thereof) either in general or specifically
        to You;
      </p>
      <p>
        <strong>or</strong>
      </p>
      <p>
        <strong>11.2.5</strong> For technical or any other reason, Termination or suspension may
        include: (i) removal of access to all or portion of the offerings on the Website or with
        respect to the Services or any portion thereof; (ii) deletion of Your materials and / or
        Account Information, including Your personal information, log-in ID and password, and all
        related information, files and materials associated with You or inside Your Account (or any
        part thereof); and (iii) barring of further use of the Website or Services. Service Provider
        may also delete any content or other materials relating to your use of the Website.
      </p>
      <p>
        <strong>11.3</strong> The notice / information as referred in pt. 11.2 above shall be served
        on your registered e-mail id / mobile number on www.smlsaarthi.com.
      </p>
      <p>
        <strong>11.4</strong> The Service Provider shall not be liable to you or any third party for
        any such termination.
      </p>
      <p>
        <strong>11.5</strong> Termination or suspension shall not affect your liability or
        obligation arising prior to such termination or suspension.
      </p>
      <p>
        <h3>12. GOVERNING LAW</h3>
      </p>
      <p>
        <strong>12.1</strong> The Terms and all transactions entered and the relationship between
        you and Service Provider and any mutual claims shall be governed in accordance with the laws
        of India.
      </p>
      <p>
        <strong>12.2</strong> All claims, differences and disputes arising under or in connection
        with or in relation hereto the Website, the Terms or any transactions entered into on or
        through the Website shall be subject to the exclusive jurisdiction of the courts at
        Chandigarh, India and You hereby accede to and accept the jurisdiction of such courts.
      </p>
      <p>
        <h3>15. GENERAL PROVISIONS</h3>
      </p>
      <p>
        <strong>Notice:</strong> All notices from Service Provider will be served by email to the
        account designated by you or by general notification on the Website. Any notice to be
        provided to Service provider pursuant to the Terms should be sent to admin@smlsaarthi.com
      </p>
      <p>
        <strong>15.1</strong> <strong>Assignment:</strong> You cannot assign or otherwise transfer
        the Terms, or any rights or obligations hereunder to any third party. Service provider‘s
        rights under the Terms of Use are freely transferable by Service provider to any third
        parties without the requirement of seeking Your consent.
      </p>
      <p>
        <strong>15.2</strong> <strong>Severability:</strong> If a court of competent jurisdiction
        finds any provision of the Terms, or portion thereof, to be unenforceable, the same shall
        not affect the provisions of any other portion of the Terms. In any event, such provision
        shall be enforced to the maximum extent permissible so as to give effect to the intent of
        the parties as reflected by that provision.
      </p>
      <p>
        <strong>15.3</strong> <strong>Waiver:</strong> Any failure by Service provider to enforce or
        exercise any provision of the Terms, or any related right, shall not constitute a waiver of
        that provision or right.
      </p>
      <p>
        <strong>15.4</strong> <strong>Feedback and Information.</strong> Any feedback you provide to
        this Website shall be deemed to be non-confidential. Service provider shall be free to use
        such information on an unrestricted basis. Further, by submitting the feedback, You
        represent and warrant that (i) Your feedback does not contain confidential or proprietary
        information of You or of third parties; (ii) Service provider is not under any obligation of
        confidentiality, express or implied, with respect to the feedback; and (iii) You are not
        entitled to any compensation or reimbursement of any kind from Service provider for the
        feedback under any circumstances.
      </p>
      <p>
        <strong>15.5</strong> We reserve the right, at our sole discretion, to change or modify
        portions of terms of use at any time. If we do this, we will post the changes on this page
        and will indicate at the top of this page the date these terms were last revised. Your
        continued use of the Services or Hardware after the date any such changes become effective
        constitutes your acceptance of the new terms of use. By visiting this Website or using our
        Services you agree to be bound by the terms and conditions.
      </p>
    </Grid>
  );
}

export default TermsConditions;
